import type {QueryClient} from '@tanstack/react-query';

import {departmentJoinKeys} from './departmentJoin/keys';
import {searchKeys} from './search/keys';

/**
 * DIS-2071: product list keys have no sign-in state, and a session changes what a list returns.
 * Measured 2026-11-04: one store returned 14 tobacco lines with a session and 0 without one.
 * Lists on screen refetch now. Other lists refetch when they next mount.
 */
export const invalidateLineQueries = (client: QueryClient): Promise<unknown> =>
  Promise.all(
    [searchKeys.all, ['global-search'], departmentJoinKeys.all].map(queryKey =>
      client.invalidateQueries({queryKey}),
    ),
  );
